<template>
  <div class="card card-info" id="app">
    <div class="card-header with-border">
      <h3 class="card-title">Evaluations</h3>
      <div style="float:right">
        <button v-on:click="news()" type="button" class="btn btn-primary btn-rounded">New</button>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12 ">
          <div class="">
            <table width="100%" class="table table-bordered table-striped table-color">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Title</th>
                  <th>Semester</th>
                  <th>ValidFrom</th>
                  <th>Valid To</th>
                  <th>Launcher</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in evaluationmaster">
                  <td>{{index+1}}</td>
                  <td>{{item.EvaluationTitle}}</td>
                  <td>{{item.Name}}</td>
                  <td>{{item.ValidFrom}}</td>
                  <td>{{item.validto}}</td>
                  <td>
                    <input type="checkbox" v-model="item.Launch" v-on:change="save(item.EvaluationMasterID,item.Launch)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        evaluationmaster: []
      }
    },
    created: function () {
      this.getdata();
    },
    mounted: function () {

    },
    updated: function () {
    },
    methods:
    {
      onchange() {
        this.course.ActiveStatus = $('#ddlStatus option:selected').text();
      },
      getdata() {
        startReq();
        var vm = this;
        vm.evaluationmaster = "";
        axios.post('/api/QECApi/getmasterdata')
          .then(function (res) {
            vm.evaluationmaster = res.data;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      save(id, launch) {
        startReq();
        var vm = this;
        axios.post('/api/QECApi/savelaunching', {
          ID: id,
          Launch: launch
        })
          .then(function (res) {
            toastr.success("Saved Successfully", "Done!");
            endReq();
            vm.getdata();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      news() {
        window.location = "../QEC/CreateEvaluation";
      }
    }
  });
</script>



// WEBPACK FOOTER //
// src/components/QEC/allevaluations.vue